import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ChangeOmaUserDetailsRequest, ChangeUserDetailsRequest } from '@vi-iot/client';

import { UserDetailsStore } from '@store';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-change-user-details-modal',
  templateUrl: './change-user-details-modal.component.html',
  styleUrls: ['./change-user-details-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeUserDetailsModalComponent implements OnInit, OnDestroy {
  userRole$ = this.userDetailsStore.getUserRole();
  personal$ = this.userDetailsStore.getUser();
  contact$ = this.userDetailsStore.getUserContact();
  address$ = this.userDetailsStore.getUserAddress();
  isEmailVerified$ = this.userDetailsStore.isEmailVerified();
  isOmaUser: boolean;

  private ngUnsubscribe$: Subject<void> = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      changeType: 'personal' | 'address' | 'contact' | 'other';
    },
    public dialogRef: MatDialogRef<ChangeUserDetailsModalComponent>,
    public userDetailsStore: UserDetailsStore
  ) {}

  ngOnInit(): void {
    this.userDetailsStore.isOmaUser$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((res) => {
      this.isOmaUser = res;
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  onOmaSave(body: ChangeOmaUserDetailsRequest): void {
    this.userDetailsStore.changeOmaUserDetails(body);
  }

  onSave(body: ChangeUserDetailsRequest): void {
    this.userDetailsStore.changeUserDetails(body);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
